import React, { useEffect, useRef, useState } from "react";
import classes from "./BimatterAssistant.module.css";
import {
    useCheckRelevanceMutation,
    useGetRelevantElementsMutation,
    useLearnMutation,
} from "../../app/services/bimatterAssistant/bimatterAssistant";
import { useAppSelector } from "../../app/hooks/hooks";
import {
    selectModels,
    selectViewer,
} from "../../app/features/viewer/viewerMainSlice";

interface BimatterAssistantProps {}

function BimatterAssistant({}: BimatterAssistantProps) {
    const textRef = useRef<HTMLDivElement>(null);
    const [text, setText] = useState(
        "Hello, I'm Alex, your BIM assistant, how can I help you?"
    );
    const [animate, setAnimate] = useState(true);
    const [hideCursor, setHideCursor] = useState(false);
    const [query, setQuery] = useState("");
    const [checkRelevance] = useCheckRelevanceMutation();
    const [getAllRelevant] = useGetRelevantElementsMutation();
    const models = useAppSelector(selectModels);
    const viewer = useAppSelector(selectViewer)();
    useEffect(() => {
        if (viewer) {
            //@ts-ignore
            viewer.settings.keysDisable = true;
        }
    }, [viewer]);
    const [learnBimatterAssistant] = useLearnMutation();
    const [getRelevantElements] = useGetRelevantElementsMutation();
    const refreshAssistant = (text: string) => {
        setAnimate(false); // Отключаем анимацию перед сменой текста
        setHideCursor(false); // Возвращаем курсор
        setTimeout(() => {
            setText(text); // Меняем текст
            setAnimate(true); // Включаем анимацию снова
        }, 10);
    };

    useEffect(() => {
        // Убираем курсор после окончания анимации
        const timeout = setTimeout(() => {
            setHideCursor(true);
        }, 2000); // Должно совпадать со временем анимации

        return () => clearTimeout(timeout);
    }, [text]); // Вызываем при смене текста
    const sendQuery = async () => {
        const hedeWords = ["скрыть", "скрой", "скройте", "hide"];
        const isolateWords = [
            "изолируй",
            "изолировать",
            "оставь",
            "оставить",
            "isolate",
            "show only",
        ];
        const selectWords = [
            "выбрать",
            "выбери",
            "выбор",
            "все",
            "выдели",
            "select",
            "get",
        ];
        if (
            hedeWords.filter((p) => query.toLocaleLowerCase().includes(p))
                .length
        ) {
            refreshAssistant("Wait a second, trying to hide elements...");
            const result = await getAllRelevant({
                query: query,
                model_id: models[0].model_id,
            }).unwrap();
            if (result.length) {
                viewer?.utils.geometryUtils.hideElementsByIds(0, result);
                refreshAssistant("Hidding complete!");
            } else {
                refreshAssistant(
                    "There are no relevant elements to this query:("
                );
            }
        } else if (
            isolateWords.filter((p) => query.toLocaleLowerCase().includes(p))
                .length
        ) {
            refreshAssistant("Wait a second, trying to isolate elements...");
            const result = await getAllRelevant({
                query: query,
                model_id: models[0].model_id,
            }).unwrap();

            if (result.length) {
                viewer?.utils.geometryUtils.isolateElementsByIds(0, result);
                refreshAssistant("Isolating complete!");
            } else {
                refreshAssistant(
                    "There are no relevant elements to this query:("
                );
            }
        } else if (query.toLowerCase().includes("это ")) {
            const result = await checkRelevance({
                query: query,
                model_id: models[0].model_id,
                element_id: viewer?.selector.selectedElements[0].values().next()
                    .value!,
            }).unwrap();
            refreshAssistant(result ? "Yes, it is!" : "No, it is not!");
        } else {
            refreshAssistant("Wait a second, trying to select elements...");
            const result = await getAllRelevant({
                query: query,
                model_id: models[0].model_id,
            }).unwrap();
            if (result.length) {
                viewer?.selector.selection.selectByIds(0, result);
                refreshAssistant("Selecting complete!");
            } else {
                refreshAssistant(
                    "There are no relevant elements to this query:("
                );
            }
        }
    };
    return (
        <div className={classes.wrap}>
            <button
                className={classes.updateButt}
                onClick={() => {
                    refreshAssistant("How can I help you?");
                }}
            >
                update
            </button>
            {/* <div style={{ position: "fixed" }}>
                <div style={{ position: "fixed", top: 100, left: 500 }}>
                    <button
                        onClick={() => {
                            learnBimatterAssistant({
                                model_id: models[0].model_id,
                                element_id: viewer?.selector.selectedElements[0]
                                    .values()
                                    .next().value,
                                query,
                                label: true,
                            });
                        }}
                    >
                        learn true
                    </button>
                    <button
                        onClick={() => {
                            learnBimatterAssistant({
                                model_id: models[0].model_id,
                                element_id: viewer?.selector.selectedElements[0]
                                    .values()
                                    .next().value,
                                query,
                                label: false,
                            });
                        }}
                    >
                        learn false
                    </button>
                    <button
                        onClick={async () => {
                            const result = await checkRelevance({
                                model_id: models[0].model_id,
                                element_id: viewer?.selector.selectedElements[0]
                                    .values()
                                    .next().value,
                                query,
                            }).unwrap();
                            console.log(result);
                        }}
                    >
                        check is wall
                    </button>
                    <button
                        onClick={async () => {
                            const result = await getRelevantElements({
                                model_id: models[0].model_id,
                                query: "стена",
                            }).unwrap();
                            viewer?.selector.selection.selectByIds(0, result);
                            console.log(result);
                        }}
                    >
                        getAllWalls
                    </button>
                </div>
            </div> */}
            <div
                ref={textRef}
                className={`${classes.typedOut} ${
                    hideCursor ? classes.hideCursor : ""
                }`}
                style={
                    {
                        animation: animate
                            ? `${classes.typing} 1.5s steps(${text.length}, end) forwards`
                            : "none",
                    } as React.CSSProperties
                }
            >
                {text}
            </div>
            <input
                type="text"
                className={classes.queryInput}
                value={query}
                onChange={(e) => {
                    setQuery(e.target.value);
                }}
            />
            <button className={classes.commitBut} onClick={sendQuery}>
                Commit
            </button>
        </div>
    );
}

export default BimatterAssistant;
